import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { isAuth } from "../../actions/auth";

const Permission = ({ permission }) => {
  const history = useHistory();
  useEffect(() => {
    const allPermissions = isAuth()?.staffRoles?.flatMap(
      (staffRole) => staffRole.role?.rolePermissions || []
    );
    const hasPermission = allPermissions.some(
      (perm) => perm.action === permission
    );
    if (!(hasPermission || isAuth().role === "admin")) {
      history.replace(`/`);
    }
  }, [permission]);

  return <></>;
};

export default Permission;
